<template>
  <div>
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Logs ready...</h3>
        </div>
      </div>
    </div>
    <div v-else>
        <div @click="$router.go(-1)" class="arrow_text cursor-pointer">
            <chevron-left-icon
            size="1.5x"
            class="custom-class"
            style="vertical-align: top;"
            ></chevron-left-icon>
            <span class="back">Back</span>
        </div>
        <h1 class="mt-2 mb-3 font-regular">
            Admin Tracks
        </h1>
      <div class="row align-items-end my-1" v-if="logs.length > 0">
        <div class="col-md-3 mt-2">
          <div class=" form-group">
            <label for="type">User</label>
            <select name="" class="form-control" v-model="user_id">
              <option value="" selected>Please Select User</option>
              <option value="" v-for="item of staffs" :key="item.id"
                >{{ item.first_name }} {{ " " }} {{ item.last_name }}</option
              >
            </select>
          </div>
        </div>        
        <div class="col-md-3 mt-2">
          <div class="form-group">
            <button @click.prevent="getLogs(1)" class=" btn button">
              <span v-if="loading" class="custom-loader">
                <loader-icon size="1.5x" class="custom-class"></loader-icon>
                <span style="font-weight: 600; text-transform: initial;"
                  >Please Wait</span
                >
              </span>
              <span v-else>Submit</span>
            </button>
          </div>
        </div>
      </div>
      <div class=" card card--no-shadow">
        <div class="card-content">
          <div class="card-body">
            <div class="card-header">
              <slot name="header">
                <h4 class="card-title">Logs</h4>
              </slot>
            </div>
            <div class="card-content">
              <div class="card-body">
                <CDataTable
                  :items="logs"
                  :fields="fields"
                  :items-per-page="small ? 10 : 5"
                  sorter
                >
                  <template #user="{item}">
                    <td class="table--action-mobile">
                      {{ item.user.first_name }} {{ item.user.last_name }}
                    </td>
                  </template>
                  <template #created_at="{item}">
                    <td class="table--action-mobile">
                      {{ item.created_at | date }}
                    </td>
                  </template>
                  <template #actions="{item}">
                    <td
                      class="table--action-mobile"
                      v-if="permissions.includes('delete-admin-track')"
                    >
                      <button
                        class="button btn-danger"
                        style="background-color: #0bc681;"
                        @click="deleteAdminTrack(item)"
                      >
                        Delete
                      </button>
                    </td>
                  </template>
                </CDataTable>
                <CPagination
                  :activePage.sync="next_page"
                  :pages="total"
                  :onActivePageChange="onPageChange()"
                ></CPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import CPagination from "@/components/CPagination.vue";
import CModal from "@/components/CModal";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
const fields = ["user", "ip_address", "created_at", 'actions'];
import { mapGetters } from "vuex";
export default {
  name: "LogsView",
  components: {
    CDataTable,
    CPagination,
    CModal
  },
  computed: {
    ...mapGetters(["userObj"]),
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  data() {
    return {
      fields,
      pageLoading: true,
      getStaffLoading: false,
      loading: true,
      small: true,
      staffs: [],
      user_id: "",
      periodParams: "",
      start_date: "",
      stop_date: "",
      next_page: 1,
      current: 1,
      total: 1,
      logs: [],
      isModalVisible: false,
      log: null
    };
  },
  methods: {
    async showUpdateModal(item) {
      this.log = Object.assign({}, item);
      console.log(this.log);
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    async getStaffs() {
      try {
        this.getStaffLoading = true;
        const response = await ApiService.get("user/staffs");

        this.staffs = response.data.data;
        this.getStaffLoading = false;
      } catch (error) {
        this.getStaffLoading = false;
        console.log(error.response);
      }
    },
    async getLogs(page) {
      try {
        const response = await ApiService.get(
          `user/admin-tracks?page=${page}&user_id=${this.user_id}`
        );

        this.logs = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.pageLoading = false;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.pageLoading = false;
        console.log(error.response);
      }
    },
    async deleteAdminTrack(item) {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        });

        if (!result.isConfirmed) {
            return;
        }
        try {
            const response = await ApiService.get(
            `user/delete-admin-track/${item.id}`
            );
            Swal.fire("Deleted!", "Admin Track has been deleted.", "success");
            this.getLogs(1);
            this.isModalVisible = false;
        } catch (error) {
            console.log(error.response);
            ErrorService.handle(error);
        }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        this.getLogs(this.next_page);
      }
    }
  },
  mounted() {
    if (this.can("staffs")) {
      this.getStaffs();
    }
    this.getLogs(1);
  }
};
</script>

<style scoped></style>
